import React from "react";
import "./styles.scss"
import { ImagePaths } from "teacherDashboard/teacher/config/class_left_nav_container/common";
const CircleAnimation = () => <div className="circle-animation"> <img src={ImagePaths.loaderGif}/> </div>

export default CircleAnimation